import React from 'react';

import styled from 'styled-components';

const StyledSectionHeading = styled.h2`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  font-size: 1.5rem;
  margin: 0 0 0.625rem 0;
  text-transform: none;
`;

const StyledHr = styled.hr`
  background-color: ${Styles.color.grey.four};
  height: 1px;
  border: 0;
`;

interface IProps {
  children: string;
  id?: string;
}

const SectionHeading = ({ children, id }: IProps) => (
  <div>
    <StyledSectionHeading id={id}>{children}</StyledSectionHeading>
    <StyledHr aria-hidden="true" />
  </div>
);

export default SectionHeading;
